// @ts-nocheck
import { Component } from '@theme/component';

/**
 * Sail custom JS. Breadcrumb Navigation Component
 *
 * @extends {Component}
 */
class Breadcrumbs extends Component {
  connectedCallback() {
    // If on a Collection page, watch for product click to save the handle
    if (this.dataset.template === 'collection') {
      this.trackCollectionHandle();
      this.showCurrentBreadcrumbs();
    }

    // If on a Product page, re-render breadcrumbs
    if (this.dataset.template === 'product') {
      this.hydrateBreadcrumbs();
    }

    if (this.dataset.template === 'page') {
      this.showCurrentBreadcrumbs();
    }
  }

  disconnectedCallback() {
    if (this.clickHandler) {
      document.removeEventListener('click', this.clickHandler);
    }
  }

  /**
   * Tracks the collection handle when a user clicks a product link.
   */
  trackCollectionHandle() {
    const collectionHandle = this.dataset.collectionHandle;
    
    if (!collectionHandle) return;

    this.clickHandler = (event) => {
      const link = event.target.closest('a');

      // Only process product links
      if (link?.href && link.href.includes('/products/')) {
        sessionStorage.setItem('previous_collection', collectionHandle);
      }
    };

    document.addEventListener('click', this.clickHandler);
  }

  hydrateBreadcrumbs() {
    const storedHandle = sessionStorage.getItem('previous_collection');

    // Fail safe in case the url has the collection, the liquid will already be correct
    const isAlreadyCorrect = storedHandle && window.location.pathname.includes(`/collections/${storedHandle}`);

    if (!storedHandle || isAlreadyCorrect) {
      this.showCurrentBreadcrumbs();

      return;
    }

    // Fetch the breadcrumb specific to the stored handle
    const productHandle = this.dataset.productHandle;
    this.fetchNewBreadcrumbsSection(storedHandle, productHandle);
  }

  /**
   * Fetches the product page rendered within the context of the previous collection
   * to get the correct breadcrumb HTML.
   * @param {string} collectionHandle
   * @param {string} productHandle
   */
  async fetchNewBreadcrumbsSection(collectionHandle, productHandle) {
    const localeRoot = (this.dataset.localeRoot || '/').replace(/\/$/, '');
    const fetchUrl = `${localeRoot}/collections/${collectionHandle}/products/${productHandle}?section_id=${this.dataset.sectionId}`;

    try {
      const response = await fetch(fetchUrl);
      if (!response.ok) throw new Error('Breadcrumb fetch error');

      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      const newBreadcrumbs = doc.querySelector('breadcrumbs-nav');

      // Replaces HTML and triggers animations
      if (newBreadcrumbs?.innerHTML) {
        this.innerHTML = newBreadcrumbs.innerHTML;
        this.showCurrentBreadcrumbs();
      } else {
        // Fallback: show original breadcrumbs
        this.showCurrentBreadcrumbs();
      }
    } catch (error) {
      console.warn('Unable to load breadcrumbs:', error);
      this.showCurrentBreadcrumbs();
    }
  }

  showCurrentBreadcrumbs() {
    const breadcrumbs = this.querySelector('.breadcrumbs.section');

    if (!breadcrumbs) return;

    breadcrumbs.classList.remove('is-hidden');
    breadcrumbs.classList.add('breadcrumbs__fade-in');
  }
}

if (!customElements.get('breadcrumbs-nav')) {
  customElements.define('breadcrumbs-nav', Breadcrumbs);
}
